import styled from 'styled-components';
export const ContentContainer = styled.div `
    p {
        margin-top: 16px;
        margin-bottom: 24px;
        font-family: 'Inter', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
    }

    form {
        input:invalid,
        textarea:invalid {
            background: ${(props) => props.showFormErrors &&
    `url(${props.invalidSvgIcon}) no-repeat 100% 50%`};
        }

        input,
        textarea {
            background-color: transparent;
            border: 1.2px solid ${(props) => props.theme.secondary};
            outline: 0;
            border-radius: 0;
            border-width: 0 0 1.2px;
            padding: 16px 0;
            flex: 1;

            border-color: ${(props) => props.theme.secondary};
            color: ${(props) => props.theme.secondary};

            font-family: 'Inter', sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 24px;

            box-sizing: border-box;

            ::-webkit-input-placeholder {
                /* Chrome/Opera/Safari */
                color: ${(props) => props.theme.secondary};
            }
            ::-moz-placeholder {
                /* Firefox 19+ */
                color: ${(props) => props.theme.secondary};
            }
            :-ms-input-placeholder {
                /* IE 10+ */
                color: ${(props) => props.theme.secondary};
            }
            :-moz-placeholder {
                /* Firefox 18- */
                color: ${(props) => props.theme.secondary};
            }

            :focus {
                border-width: 0 0 2.4px;
            }
        }

        input {
            :-webkit-autofill,
            :-webkit-autofill:hover,
            :-webkit-autofill:focus,
            :-webkit-autofill:active {
                -webkit-box-shadow: 0 0 0 60px ${(props) => props.theme.primary}
                    inset !important;

                box-shadow: 0 0 0 60px ${(props) => props.theme.primary} inset !important;

                background-color: ${(props) => props.theme.primary} !important;

                background-clip: content-box !important;
                -webkit-text-fill-color: ${(props) => props.theme.secondary} !important;
            }
        }

        textarea {
            resize: none;
            box-sizing: border-box;
        }

        .submitButton {
            margin-top: 40px;
        }
    }
`;
export const FormGroup = styled.div `
    display: flex;
    margin-top: 24px;
    min-height: 60px;

    &:first-child {
        margin-top: 0;
    }
`;
